import { colors } from '@munifocus/tokens';

/**
 * The inks for marking up evidence photos, keyed by the colour names
 * contracts-gov records (`MARKUP_COLOURS`). Drawn over photographs, not the
 * page, so they are not portal-accented.
 */
export const markupInks = colors.markup;
